export default {
  setInspectionLevel(state, data) {
    state.inspectionLevel = data;
  },
  setInspectionLevelCode(state, data) {
    state.inspectionLevelCode = data;
  },

  setProductionGroups(state, data) {
    state.productionGroups = data;
  },
  setProductionGroup(state, data) {
    state.productionGroup = data;
  },
  setProductionGroupsCode(state, data) {
    state.productionGroupsCode = data;
  },

  setProductionGroupSupplier(state, data) {
    state.productionGroupSupplier = data;
  },
  setProductionGroupSupplierCode(state, data) {
    state.productionGroupSupplierCode = data;
  },

  setPurchaseContracts(state, data) {
    state.purchaseContracts = data;
  },
  setPurchaseContractsCode(state, data) {
    state.purchaseContractsCode = data;
  },

  setSaleTypes(state, data) {
    state.saleTypes = data;
  },
  setSaleTypesCode(state, data) {
    state.saleTypesCode = data;
  },

  setStopStations(state, data) {
    state.stopStations = data;
  },
  setStopStationsCode(state, data) {
    state.stopStationsCode = data;
  },

  setOrders(state, data) {
    state.orders = data;
  },
  setOrder(state, data) {
    state.order = data;
  },
  setOrdersCode(state, data) {
    state.ordersCode = data;
  },
  setOrderCommodityAttachment(state, data) {
    state.orderCommodityAttachment = data;
  },

  setOrderDataSheets(state, data) {
    state.orderDataSheets = data;
  },
  setOrderDataSheet(state, data) {
    state.orderDataSheet = data;
  },
  setOrderDataSheetCode(state, data) {
    state.orderDataSheetCode = data;
  },

  setSettings(state, data) {
    state.settings = data;
  },

  setTechnicalCartable(state, data) {
    state.technicalCartable = data;
  },

  setMapConfirmCartable(state, data) {
    state.mapConfirmCartable = data;
  },

  setInventoryControlCartable(state, data) {
    state.inventoryControlCartable = data;
  },

  setDeliveryDateCartable(state, data) {
    state.deliveryDateCartable = data;
  },

  setConfirmDeliveryDateCartable(state, data) {
    state.confirmDeliveryDateCartable = data;
  },

  setIsNeedPlanCartable(state, data) {
    state.isNeedPlanCartable = data;
  },

  setSellCartable(state, data) {
    state.sellCartable = data;
  },

  setCommodityAdditionalInfo(state, data) {
    state.commodityAdditionalInfo = data;
  },

  setBomCommodities(state, data) {
    state.bomCommodities = data;
  },

  setBoms(state, data) {
    state.boms = data;
  },

  setOrderCommodityReservation(state, data) {
    state.orderCommodityReservation = data;
  },

  setCommodityInventoryWare(state, data) {
    state.commodityInventoryWare = data;
  },

  setOrderCommodityStatusLogs(state, data) {
    state.orderCommodityStatusLogs = data;
  },

  setModiranMappings(state, data) {
    state.modiranMappings = data;
  },

  setModiranSideWares(state, data) {
    state.modiranSideWares = data;
  },

  setModiranSideVoucherTypes(state, data) {
    state.modiranSideVoucherTypes = data;
  },

  setModiranSideLoading(state, data) {
    state.modiranSideLoading = data;
  },

  setModiranSideError(state, data) {
    state.modiranSideError = data;
  },
};
